import * as React from 'react';
import { compose, withProps } from 'recompose';
import { skin, OemProps } from 'ui/styles/skin';

export type OwnProps = React.SelectHTMLAttributes<HTMLSelectElement>;

export const RawSelect = ({ styles, children, ...props }: OwnProps & RecomposeProps & OemProps) =>
    <select
        { ...props }
    >
        { children }
    </select>
;

type RecomposeProps = {
    style: {};
};

export const Select = compose<OwnProps & RecomposeProps & OemProps, OwnProps>(
    skin,
    withProps(({ style = {}, styles }: OemProps & OwnProps) => ({
        style: {
            ...styles.Input,
            ...style,
        },
    })),
)(RawSelect);



// WEBPACK FOOTER //
// ./src/ui/shared/Select.tsx